import axios from "axios";
import { LOGIN_URL } from "../../configuration/Utils/constService";

export const logIn = (data) => axios.post(LOGIN_URL, data);